export default class DragScroll {

    scrollContainer: HTMLElement;
    positionLeft = 0;
    positionX = 0;

    /** Mouse Down handler with bound this context */
    mouseDownHandler: (ev: PointerEvent) => void;
    /** Mouse Move handler with bound this context */
    mouseMoveHandler: (ev: PointerEvent) => void;
    /** Mouse Up handler with bound this context */
    mouseUpHandler: () => void;
    dragScrollWatcher: () => void;

    constructor(scrollContainer: HTMLElement) {
        this.scrollContainer = scrollContainer;
        this.mouseDownHandler = (ev: PointerEvent) => {
            this.onMouseDown(ev);
        }
        this.mouseMoveHandler = (ev: PointerEvent) => {
            this.onMouseMove(ev);
        }
        this.mouseUpHandler = () => {
            this.onMouseUp();
        }
        this.dragScrollWatcher = () => {
            this.onScrollWatch();
        }
    }

    /**
     * Initialize listeners for drag-scrolling on the given container
     */
    mounted() {
        this.onScrollWatch();
        window.addEventListener('resize', this.dragScrollWatcher);
    }

    /**
     * Remove listeners when destroying component
     */
    beforeDestroy() {
        this.stopDragScroll();
        window.removeEventListener('resize', this.dragScrollWatcher);
    }

    hasTouchScreen() {
        return ('ontouchstart' in globalThis);
    }

    onScrollWatch() {
        if (this.hasTouchScreen()) {
            this.stopDragScroll();
        } else {
            this.startDragScroll();
        }
    }

    startDragScroll() {
        this.scrollContainer.addEventListener('mousedown', this.mouseDownHandler);
        this.scrollContainer.classList.add('scrolling-enabled');
    }

    stopDragScroll() {
        this.scrollContainer.removeEventListener('mousedown', this.mouseDownHandler);
        this.scrollContainer.classList.remove('scrolling-enabled');
        this.onMouseUp();
    }

    onMouseDown(e) {
        this.scrollContainer.classList.add('scrolling-active');
        this.positionLeft = this.scrollContainer.scrollLeft;
        this.positionX = e.clientX;
        this.scrollContainer.addEventListener('mousemove', this.mouseMoveHandler);
        this.scrollContainer.addEventListener('mouseup', this.mouseUpHandler);
    }

    onMouseMove(e) {
        const dx = e.clientX - this.positionX;
        this.scrollContainer.scrollLeft = this.positionLeft - dx;
    }

    onMouseUp() {
        this.scrollContainer.removeEventListener('mousemove', this.mouseMoveHandler);
        this.scrollContainer.removeEventListener('mouseup', this.mouseUpHandler);
        this.scrollContainer.classList.remove('scrolling-active');
    }
}
